import React, {createContext, useContext, useState, useMemo} from 'react'
import PropTypes from 'prop-types'

// Create the context
export const CustomToastContext = createContext()

// Custom hook to use the context
export const useCustomToast = () => useContext(CustomToastContext)

// Provider component
export const CustomToastProvider = ({children}) => {
    const [showToastMessage, setShowToastMessage] = useState(false)
    const [toastMessage, setToastMessage] = useState('')
    const [toastAction, setToastAction] = useState(null)
    const [toastStyles, setToastStyles] = useState({})
    const [toastMessageStyles, setToastMessageStyles] = useState({})
    const [toastContainerId, setToastContainerId] = useState('')
    const [toastContainerRef, setToastContainerRef] = useState(null)
    const [toastDuration, setToastDuration] = useState(3000) // Default duration of 3000ms
    const [onClose, setOnClose] = useState(() => () => {}) // Default to a no-op function

    // Function to show toast
    const showCustomToast = ({
        message,
        action,
        styles,
        messageStyles,
        containerId,
        toastContainerRef,
        duration,
        onClose
    }) => {
        setToastMessage(message)
        setToastAction(action)
        setToastStyles(styles)
        setToastMessageStyles(messageStyles)
        setToastContainerId(containerId)
        setToastContainerRef(toastContainerRef)
        setToastDuration(duration || 3000) // Use default if duration is not provided
        setOnClose(() => onClose || (() => {})) // Set onClose or default to no-op
        setShowToastMessage(true)
    }

    // Memoize the context value
    const value = useMemo(
        () => ({
            showToastMessage,
            setShowToastMessage,
            toastMessage,
            setToastMessage,
            toastAction,
            setToastAction,
            toastStyles,
            setToastStyles,
            toastMessageStyles,
            setToastMessageStyles,
            toastContainerId,
            toastContainerRef,
            setToastContainerId,
            setToastContainerRef,
            toastDuration,
            setToastDuration,
            onClose,
            setOnClose,
            showCustomToast
        }),
        [
            showToastMessage,
            toastMessage,
            toastAction,
            toastStyles,
            toastMessageStyles,
            toastContainerId,
            toastContainerRef,
            toastDuration,
            onClose
        ]
    )

    return <CustomToastContext.Provider value={value}>{children}</CustomToastContext.Provider>
}

CustomToastProvider.propTypes = {
    children: PropTypes.node.isRequired
}
